module.exports = new __parcel__URL__("popup-errors.b6717bd6.png").toString();